// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"90dab17d","537":"79c4b765"}[chunkId] + ".chunk.css";
};